import { render, staticRenderFns } from "./Pl3.vue?vue&type=template&id=327e6be8&scoped=true"
import script from "./Pl3.vue?vue&type=script&lang=js"
export * from "./Pl3.vue?vue&type=script&lang=js"
import style0 from "./Pl3.vue?vue&type=style&index=0&id=327e6be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e6be8",
  null
  
)

export default component.exports